import { render, staticRenderFns } from "./RulesGroupDeleteModal.vue?vue&type=template&id=0498c193&"
import script from "./RulesGroupDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./RulesGroupDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports